export const EXERCISE_DATA_REQUEST = 'EXERCISE_DATA_REQUEST';
export const EXERCISE_DATA_SUCCESS = 'EXERCISE_DATA_SUCCESS';
export const EXERCISE_DATA_FAIL = 'EXERCISE_DATA_FAIL';
